import CommonService from 'services/api/CommonService';
import {
    ACTIVE_UPDATE_FILE_LIST,
    DISABLE_UPDATE_FILE_LIST,
    UPDATE_LAST_ROUTE
} from '../redux/common/Types'

const commonService = new CommonService()

export const updateLastRoute = payload => ({
    type: UPDATE_LAST_ROUTE,
    payload: payload
})

export const updateFileList = (option) => async dispatch => {
    if(option){
        dispatch({ type: ACTIVE_UPDATE_FILE_LIST })
    }else{
        dispatch({ type: DISABLE_UPDATE_FILE_LIST })
    }
}

// export const getIncomingOrders = () => async dispatch => {
//     try{
//         const res = await commonService.getIncomingOrders()
//         dispatch( {
//             type: GET_INCOMING_ORDERS,
//             payload: res.data
//         });
//         return res.data;
//     }
//     catch(e){
//         dispatch( {
//             type: ORDERS_ERROR,
//             payload: console.log(e),
//         })
//     }
// }